module.exports = __webpack_public_path__ + "media/images/faces/face17-4d6b140291ba9b38d9915feb7b09e761.jpg";